"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M8.42466 6.77492C8.46216 6.36241 8.82697 6.0584 9.23948 6.0959L17.0177 6.80301C17.3782 6.83579 17.6639 7.12146 17.6967 7.48203L18.4038 15.2602C18.4413 15.6727 18.1373 16.0375 17.7248 16.075C17.3123 16.1125 16.9474 15.8085 16.9099 15.396L16.3478 9.21253L7.58059 17.9798C7.2877 18.2726 6.81283 18.2726 6.51993 17.9798C6.22704 17.6869 6.22704 17.212 6.51993 16.9191L15.2872 8.15187L9.10368 7.58974C8.69117 7.55224 8.38716 7.18743 8.42466 6.77492Z';